/* eslint-disable */

import React, { FC, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import RaindropDivider from "../raindrop-divider/raindrop-divider";
import { motion } from "framer-motion";

const RaindropFader = ({ isVisible }) => {
  let fadeOutOpacity = "opacity-0";

  if (isVisible) {
    fadeOutOpacity = "opacity-100";
  }

  return (
    <div
      className={`h-full absolute w-full flex flex-col justify-end pointer-events-none z-10 ${fadeOutOpacity} transition-all`}
    >
      <div
        className={`h-20 w-full bg-gradient-to-b from-transparent  transition-all absolute 
        dark:to-black to-white
        `}
      ></div>
    </div>
  );
};

interface RaindropScrollContainerProps {
  id?: string;
  children?: ReactNode;
  onScroll?: (e: any) => void;
  additionalClassNames?: string;
}
const RaindropScrollContainer: FC<RaindropScrollContainerProps> = ({
  id = "raindrop-scroll-container",
  children = null,
  onScroll = () => {},
  additionalClassNames = "",
}) => {
  const elementRef = useRef(null);

  const [showDividerTop, setShowDividerTop] = useState(false);
  const [showDividerBottom, setShowDividerBottom] = useState(false);

  const onInternalScroll = (e) => {
    const newScrollYProgress =
      e.target.scrollTop / (e.target.scrollHeight - e.target.offsetHeight);

    setShowDividerTop(newScrollYProgress > 0.01);
    setShowDividerBottom(newScrollYProgress < 0.99);
    onScroll(e);
  };

  if (children === null || children === undefined) {
    children = Array(20).fill(
      <div className="p-6 w-full rounded-lg bg-color-background-secondary dark:bg-color-dark-background-secondary" />
    );
  }

  useEffect(() => {
    setShowDividerBottom(
      elementRef.current.offsetHeight < elementRef.current.scrollHeight
    );
  }, []);

  return (
    <div
      id={`${id}-container`}
      className={"flex flex-col h-full w-full overflow-y-auto"}
    >
      <RaindropDivider isHidden={!showDividerTop} />

      <div
        id={id}
        onScroll={onInternalScroll}
        ref={elementRef}
        className={`flex flex-col h-full w-full no-scrollbar overflow-x-auto overflow-y-auto gap-2 items-center ${additionalClassNames}`}
      >
        {children}
      </div>

      <RaindropDivider isHidden={!showDividerBottom} />
    </div>
  );
};

export default RaindropScrollContainer;
